import { loadStripe, Stripe } from "@stripe/stripe-js";

const getStripeInstance = (publishableKey: string): Promise<Stripe | null> => {
  return loadStripe(publishableKey);
};

export default getStripeInstance;
